/**
 * gradientForName — deterministic CSS gradient from a string.
 * Used as a cover fallback when no image is available.
 * Same input always produces same gradient (pure function, no random).
 */

const PALETTE = [
  ['#C28B5C', '#8B5E3C'],
  ['#4A0E4E', '#8B1A8C'],
  ['#006D6F', '#00A3A5'],
  ['#D17BB0', '#9B4D80'],
  ['#FF7F50', '#CC5522'],
  ['#FF4500', '#CC2200'],
  ['#3A7BD5', '#1A4A9C'],
  ['#2ECC71', '#1A7A44'],
  ['#F39C12', '#C0770A'],
  ['#E74C3C', '#A93226'],
  ['#9B59B6', '#6C3483'],
  ['#1ABC9C', '#148F77'],
];

/**
 * Deterministic hash for a string (djb2 variant).
 * Returns a non-negative integer.
 */
function hashStr(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) ^ str.charCodeAt(i);
  }
  return Math.abs(h);
}

/**
 * Returns a CSS linear-gradient string for the given name.
 * @param {string} name - playlist name or id
 * @param {number} [angle=135] - gradient angle in degrees
 * @returns {string} CSS gradient value
 */
export function gradientForName(name, angle = 135) {
  const idx = hashStr(name || 'default') % PALETTE.length;
  const [c1, c2] = PALETTE[idx];
  return `linear-gradient(${angle}deg, ${c1} 0%, ${c2} 100%)`;
}
